import { render } from "./ContentControlButton.vue?vue&type=template&id=61bda08e&scoped=true&ts=true"
import script from "./ContentControlButton.vue?vue&type=script&lang=ts"
export * from "./ContentControlButton.vue?vue&type=script&lang=ts"

import "./ContentControlButton.vue?vue&type=style&index=0&id=61bda08e&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bda08e"]])

export default __exports__